var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"align-h":_vm.horizontalAlign,"align-v":_vm.verticalAlign,"cols":_vm.cols},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }